import React from "react";

export default function Html(props) {

  const {
    html = "",
    className = "",
    style = {}
  } = props;

  return (
    <div
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}